export default __webpack_public_path__ + "static/media/memefivestages.73641c93.jpeg";